import axios, { AxiosPromise } from 'axios';
import { IConsignmentStorage } from '../../../@types/model/compliance/titan-TUR/consignmentStorage';

export default class ConsignmentHttpService {
    public static getConsignmentData() : AxiosPromise<Array<IConsignmentStorage>> {
        return axios.get(`${API_URL}/v1/Consignment`);
    }

    public static addOrUpdateConsignment(data : IConsignmentStorage) : AxiosPromise<IConsignmentStorage> {
        return axios.post(`${API_URL}/v1/Consignment/PostConsignment`, data);
    }
}
